import { ApiClient } from './client.js'
import { LICENSES } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (licenseId) {
    return client.get(`${LICENSES}${licenseId}/`)
  },

  pdf (licenseId) {
    return client.get(`${LICENSES}${licenseId}/pdf/`, {
      responseType: 'arraybuffer'
    })
  },

  list () {
    return client.get(`${LICENSES}`)
  },

  listAll () {
    return client.getAll(`${LICENSES}`)
  },

  lite () {
    return client.get(`${LICENSES}lite/`)
  },

  liteAll () {
    return client.getAll(`${LICENSES}lite/`)
  }
}
